<template>
  <div class="w-full h-full relative cursor-pointer">
    <div
      id="uniqueChoie"
      ref="uniqueChoie"
      class="w-full h-full rounded-lg flex items-center px-2"
      @click.stop="renderOptions"
    >
      <span class="truncate w-full inline-block">
        <span class="font-bold">{{ optionSelected.length }} </span>
        Elementos Seleccionados
      </span>
      <div class="flex flex-col cursor-pointer">
        <i class="material-icons p-0 m-0" style="font-size: 22px; line-height: 0.4"> arrow_drop_up </i>
        <i class="material-icons p-0 m-0" style="font-size: 22px; line-height: 0.4"> arrow_drop_down </i>
      </div>
    </div>

    <div
      ref="nodeListOptions"
      class="ccf746de-a382-4581-a246-92482498152c mt-10 absolute bg-white w-full z-1000"
      @click.stop
    >
      <ul class="bg-white z-1000 border w-full heightListOptions overflow-auto rounded">
        <li class="px-2 py-2 flex items-center border border-r-0 border-t-0 border-l-0">
          <i class="material-icons p-0 m-0 mr-2" style="font-size: 16px; line-height: 0.4"> search </i>
          <input
            v-model.trim="searchOption"
            class="w-full h-6 border-0 font-family"
            type="text"
            placeholder="Buscar..."
          />
        </li>
        <li
          class="px-2 py-1 cursor-pointer Options_"
          :class="{ optionSelected: optionSelected.includes(option) }"
          v-for="(option, j) in filterOptions"
          :key="j"
          @click.stop="selectedOption(option)"
        >
          {{ option.text || option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "question"],
  data() {
    return {
      nodeListOptions: null,
      isTap: false,
      searchOption: "",
      optionSelected: this.value,
      options: this.question.options
    };
  },
  mounted() {
    this.nodeListOptions = this.$refs.nodeListOptions;
    const existElements = document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
    if (existElements.length > 0) this.removeElements();
  },
  methods: {
    /**
     * Verifica si la opción esta agregada a la lista, si lo esta lo remueve de la lista de lo contrario lo agrega.
     * @param {string} text
     */
    selectedOption(text) {
      if (this.optionSelected.includes(text)) {
        this.optionSelected = this.optionSelected.filter(option => {
          if (option.value) return option.value !== text.value;
          return option !== text;
        });
      } else this.optionSelected.push(text);

      const answers = this.optionSelected.map(option => option.text || option);
      this.$emit("input", answers);
    },
    /**
     * Renderiza y agrega funcionalidad para visualizar la lista de opciones multiples o removerlas de la vista.
     */
    renderOptions() {
      this.searchOption = "";
      const body = document.body;
      body.onclick = () => this.removeElements();

      if (this.isDisplay()) return this.removeElements();

      const existElements = document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
      if (existElements.length > 0) this.removeElements();

      const uniqueChoie = this.$refs.uniqueChoie;
      const currendDiv = uniqueChoie.parentNode;

      currendDiv.insertBefore(this.nodeListOptions, uniqueChoie);
    },
    /**
     * Remueve del html la lista de opciones
     */
    removeElements() {
      const elements = document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    },
    isDisplay() {
      return this.$refs.nodeListOptions.offsetWidth > 0 ? true : false;
    }
  },
  computed: {
    /**
     * Filtra las opciones por busqueda de un string
     */
    filterOptions() {
      return this.options.filter(option => {
        if (this.searchOption.length > 0) {
          if (option.text) return option.text.toLowerCase().includes(this.searchOption.toLowerCase());
          return option.toLowerCase().includes(this.searchOption.toLowerCase());
        }
        return true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
}
.heightListOptions {
  max-height: 16rem;
}

.z-1000 {
  z-index: 1000000;
}

.Options_:hover {
  background-color: #e6e6e6;
}

.optionSelected {
  background-color: rgb(56, 189, 170);
  color: #ffff;
}

.optionSelected::before {
  content: "\2714";
  color: #2efec8;
  margin-right: 5px;
}
</style>
